var Notify = (function () {
    function Notify() {
        this.handlers = [];
    }
    Notify.prototype.add = function (handler) {
        this.handlers.push(handler);
    };
    return Notify;
}());
export { Notify };
//# sourceMappingURL=Notify.js.map